import { forwardRef, useImperativeHandle, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, Theme, useMediaQuery } from "@mui/material";
import { AddPortfolio, AddPortfolioHandle } from "@features/add/AddPortfolio";
import AddIcon from "@icons/myicons/plus.svg?react";

export interface DashboardActionsHandle {
  openModal: () => void;
}

export const DashboardActions = forwardRef<DashboardActionsHandle>(
  (_props, ref) => {
    const { t } = useTranslation();
    const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    const addPortfolioRef = useRef<AddPortfolioHandle>(null);

    useImperativeHandle(
      ref,
      () => ({
        openModal: () => addPortfolioRef.current?.openModal(),
      }),
      []
    );

    return (
      <AddPortfolio
        ref={addPortfolioRef}
        anchor={
          <Button
            variant="primary"
            startIcon={<AddIcon width="18px" height="12px" />}
            data-testid="add-account"
            sx={{ width: isXs ? "100%" : "auto" }}
          >
            {t("dashboardPage.dashboard.header.add")}
          </Button>
        }
      />
    );
  }
);
